import ApplicationController from './application_controller'

/* This is the custom StimulusReflex controller for the Bid Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  /*
   * Regular Stimulus lifecycle methods
   * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
   *
   * If you intend to use this controller as a regular stimulus controller as well,
   * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
   *
   * Important:
   * By default, StimulusReflex overrides the -connect- method so make sure you
   * call super if you intend to do anything else when this controller connects.
   */

  beforeReflex(element, reflex, noop, reflexId) {
    var $el = $(element);

    // Safety net: correct bidder_id before reflex fires
    var bidderField = $el.find('input[name="bidder_id"]');
    if (window.givsum_user_id && bidderField.length && String(bidderField.val()) !== String(window.givsum_user_id)) {
      console.log('[AUCTION_DIAG] bid_controller beforeReflex FIXING bidder_id | was=' + bidderField.val() + ' | now=' + window.givsum_user_id);
      bidderField.val(window.givsum_user_id);
    }

    var formBidderId = $el.find('input[name="bidder_id"]').val();
    var identityMatch = String(window.givsum_user_id) === String(formBidderId) ? 'MATCH' : 'MISMATCH';
    console.log(`[AUCTION_DIAG] bid_controller beforeReflex | window.givsum_user_id=${window.givsum_user_id} | form.bidder_id=${formBidderId} | ${identityMatch} | reflex=${reflex} | reflexId=${reflexId}`);
    if (identityMatch === 'MISMATCH') {
      console.error(`[AUCTION_DIAG] IDENTITY MISMATCH DETECTED! window.givsum_user_id=${window.givsum_user_id} but form.bidder_id=${formBidderId}. The bid will be placed as the WRONG USER.`);
    }

    console.log(element);
    console.log(element.dataset);
    console.log($(element));

    console.log(reflex);
    var $element = $(element);

    // Pull current user's last bid
    var auctionItemId = parseInt($element.find('input[name="auction_item_id"]')[0].value);
    var opportunityId = parseInt($element.find('input[name="opportunity_id"]')[0].value);
    var auctionBidAmount = $element.find('input[name="amount"]')[0].value;
    console
    console.log('this is active')
    console.log('bid amount')
    var myBidsMap =  JSON.parse(localStorage.getItem('userBidsMap'));
    if (myBidsMap[auctionItemId]) {
      myBidsMap[auctionItemId].amount = auctionBidAmount;
    } else {
      myBidsMap[auctionItemId] = {
        store_item_id: auctionItemId,
        amount: auctionBidAmount,
        opportunity_id: opportunityId
      }
    }
    localStorage.setItem('userBidsMap', JSON.stringify(myBidsMap));
    var numberOfItemBids = Object.keys(myBidsMap).length;
    $('#my-bids-tab').text(`My Bids (${numberOfItemBids})`);
  }


  connect() {
    super.connect()
    console.log('connected here bid controller')

  }


  /* Reflex specific lifecycle methods.
   *
   * For every method defined in your Reflex class, a matching set of lifecycle methods become available
   * in this javascript controller. These are optional, so feel free to delete these stubs if you don't
   * need them.
   *
   * Important:
   * Make sure to add data-controller="bid" to your markup alongside
   * data-reflex="Bid#dance" for the lifecycle methods to fire properly.
   *
   * Example:
   *
   *   <a href="#" data-reflex="click->Bid#dance" data-controller="bid">Dance!</a>
   *
   * Arguments:
   *
   *   element - the element that triggered the reflex
   *             may be different than the Stimulus controller's this.element
   *
   *   reflex - the name of the reflex e.g. "Bid#dance"
   *
   *   error/noop - the error message (for reflexError), otherwise null
   *
   *   reflexId - a UUID4 or developer-provided unique identifier for each Reflex
   */

  // Assuming you create a "Bid#dance" action in your Reflex class
  // you'll be able to use the following lifecycle methods:

  // beforeDance(element, reflex, noop, reflexId) {
  //  element.innerText = 'Putting dance shoes on...'
  // }

  // danceSuccess(element, reflex, noop, reflexId) {
  //   element.innerText = '\nDanced like no one was watching! Was someone watching?'
  // }

  // danceError(element, reflex, error, reflexId) {
  //   console.error('danceError', error);
  //   element.innerText = "\nCouldn\'t dance!"
  // }

  // afterDance(element, reflex, noop, reflexId) {
  //   element.innerText = '\nWhatever that was, it\'s over now.'
  // }

  // finalizeDance(element, reflex, noop, reflexId) {
  //   element.innerText = '\nNow, the cleanup can begin!'
  // }

  increment(e) {
    var amount = this.amount;
    amount.replace(/[$,]+/g, "");
    amount += this.minimumBidIncrement
    this.amount = amount.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }

  decrement(e) {
    var amount = this.amount;
    amount.replace(/[$,]+/g, "");
    amount -= this.minimumBidIncrement
    amount -= this.minimumBidIncrement
    if (amount < this.minimumBid) {
      amount = this.minimumBid
    }
    this.amount = amount.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });


  }



  submit(e) {
    e.preventDefault();
    e.target.disabled = true;
    document.body.classList.add('wait');

    var form = this.element;

    // Guard: always set bidder_id from window.givsum_user_id before submitting
    var bidderField = $(form).find('input[name="bidder_id"]');
    if (window.givsum_user_id && bidderField.length) {
      if (String(bidderField.val()) !== String(window.givsum_user_id)) {
        console.log('[AUCTION_DIAG] bid_controller SUBMIT FIXING bidder_id | was=' + bidderField.val() + ' | now=' + window.givsum_user_id);
      }
      bidderField.val(window.givsum_user_id);
    }
    if (!window.givsum_user_id) {
      console.error('[AUCTION_DIAG] bid_controller BLOCKED - no givsum_user_id, cannot submit bid');
      e.target.disabled = false;
      document.body.classList.remove('wait');
      return;
    }

    // Log all hidden fields in the form being submitted
    var formBidderId = bidderField.val();
    var formAuctionItemId = $(form).find('input[name="auction_item_id"]').val();
    var formAmount = $(form).find('input[name="amount"]').val();
    var formWinningUserIds = $(form).find('input[name="winning_user_ids"]').val();
    console.log(`[AUCTION_DIAG] bid_controller SUBMIT | window.givsum_user_id=${window.givsum_user_id} | form.bidder_id=${formBidderId} | form.auction_item_id=${formAuctionItemId} | form.amount=${formAmount} | form.winning_user_ids=${formWinningUserIds} | match=${String(window.givsum_user_id) === String(formBidderId) ? 'MATCH' : 'MISMATCH'}`);

    this.stimulate('BidReflex#bid').then(() => {
      // this.element.reset()
      console.log('we are back')
        // initMap();
        // pageSetup();
      document.body.classList.remove('wait');
      console.log('after reflex');


      // optional: set focus on the freshly cleared input
      // this.focusTarget.focus()
    })
  }

  cancelBid(e) {
    console.log('cancelling bid');
    e.preventDefault();
    e.target.disabled = true;
    // document.body.classList.add('wait');
    console.log('before reflex');


    this.stimulate('BidReflex#cancel_bid').then(() => {
      // this.element.reset()
      console.log('we are back')
        // initMap();
        // pageSetup();
      document.body.classList.remove('wait');
      console.log('after reflex');


      // optional: set focus on the freshly cleared input
      // this.focusTarget.focus()
    })
  }
}
